import React from 'react';
import { observer } from 'mobx-react';
import { Button, Divider } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { IOrderView } from '../../../interfaces';
import { useUiIsLoading } from '../../../hooks';
import { stringMoney } from '../../../instruments';
import { tB } from '../../../translate';
import {
    CardInfoToolBar,
    CardLayout,
    CardMainLayout,
    Catcher,
    FieldInfo,
    LinkComponent,
    cardLayoutOptions,
} from '../../../Components';
import Styles from '../../styles/m_itemCardStyles.less';

interface IShowOrder {
    order: IOrderView;
    refreshOrder(): void;
}

export const ShowOrder: React.FC<IShowOrder> = observer(({ order, refreshOrder }: IShowOrder) => {
    const isLoading = useUiIsLoading();

    return (
        <Catcher>
            <CardMainLayout idSpinners={['GET_ORDER']}>
                <FieldInfo title={'Company'}>
                    <LinkComponent
                        currentListComponent={'CompaniesList'}
                        id={order.companyId?.id}
                        name={order.companyId?.name}
                    />
                </FieldInfo>
                <FieldInfo title={'Date'}>{order.updatedAt}</FieldInfo>
                <FieldInfo title={'Bought By'}>
                    <LinkComponent
                        currentListComponent={'UsersList'}
                        id={order?.user?.id}
                        isLight
                        name={order?.user?.name}
                    />
                </FieldInfo>
                <FieldInfo title={'Transaction id'}>{order.transactionId}</FieldInfo>
                <FieldInfo title={'Payment Method'}>{order.paymentTypeId}</FieldInfo>
                <FieldInfo title={'Description'}>{order.description}</FieldInfo>
                <FieldInfo title={'Cost'}>{stringMoney(order.amount, order.currencyId?.abbreviation)}</FieldInfo>
                <FieldInfo title={'Status'}>{order.status}</FieldInfo>
                <FieldInfo title={'Notes'}>{order.notes}</FieldInfo>
                <CardInfoToolBar>
                    <Button
                        type="primary"
                        onClick={refreshOrder}
                        icon={<SyncOutlined />}
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        {tB('Refresh')}
                    </Button>
                </CardInfoToolBar>
            </CardMainLayout>
            {order.discount?.amount ? (
                <CardLayout idSpinners={['GET_ORDER']} titleLeft={'Discount'}>
                    <FieldInfo title={'Amount'}>
                        {order.discount?.amount}{' '}
                        {order.discount?.amountType === 'percentage' ? '%' : order.currencyId?.abbreviation}
                    </FieldInfo>
                    <FieldInfo title={'Description'}>{order.discount?.description}</FieldInfo>
                </CardLayout>
            ) : null}
            {order?.products?.length ? (
                <CardLayout
                    idSpinners={['GET_COMPANY_MONTHLY_PAYMENTS', 'GET_COMPANY']}
                    titleLeft={'Products'}
                    columnOption={cardLayoutOptions.mrcForm}
                >
                    <div className={Styles.mrcFormItem}>
                        {order?.products.map((value, index) => {
                            const total = value.units * value.unitPrice;
                            const unitPriceParsed = Number(value.unitPrice);

                            return (
                                <div className={Styles.mrcFormItemContainer} key={index}>
                                    <FieldInfo title={'Units'}>{value.units}</FieldInfo>
                                    <FieldInfo title={'Price'}>
                                        {order.currencyId?.abbreviation} {unitPriceParsed.toFixed(2)}
                                    </FieldInfo>
                                    <Divider />
                                    <div style={{ color: 'green', fontSize: '16px' }}>
                                        Total: {order.currencyId?.abbreviation} {total.toFixed(2)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardLayout>
            ) : null}
        </Catcher>
    );
});
